import { Bee } from "./bee";
import { ArrowIcon } from "./ArrowIcon";
import { Dot } from "./Dots";
import { TargetAndTransition, VariantLabels, Transition } from "framer-motion";

// Tipi animazioni
interface AnimationConfig {
  animate?: TargetAndTransition | VariantLabels;
  transition?: Transition;
}

// Props base
interface BaseElement {
  id: string;
  position: string;
  animation?: AnimationConfig;
  className?: string;
}

// Props specifiche - RIMOSSO size dai props della Bee
interface BeeElement extends BaseElement {
  type: "bee";
  Component: typeof Bee;
  props?: Record<string, never>; // Ora vuoto, le dimensioni si gestiscono via className
}

interface ArrowElement extends BaseElement {
  type: "arrow";
  Component: typeof ArrowIcon;
  props?: {
    whileHover?: TargetAndTransition | VariantLabels;
  };
}

interface DotElement extends BaseElement {
  type: "dot";
  Component: typeof Dot;
  props?: React.ComponentProps<typeof Dot>;
}

// Union type
export type DecorativeElement = BeeElement | ArrowElement | DotElement;

// Stili dots - esportati per riutilizzo
export const DOT_CLASSES = {
  small: "w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 rounded-full",
  medium: "w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 rounded-full",
} as const;

export const DOT_COLORS = {
  red: "bg-[#e8501d] shadow-orange-600/30",
  yellow: "bg-[#f9b131] shadow-yellow-400/30",
  cyan: "bg-[#39a8e0] shadow-blue-400/30",
} as const;

// Esporta i componenti
export const COMPONENTS = {
  Bee,
  ArrowIcon,
  Dot,
};
